<template>

  <auto-complete-master-data-select
          :display-type="displayType"
          :label="label"
          :prepared-options="getOptions"
          :init-value-id="value"
          :watch-value-id="selectedValue"
          :on-item-changed="handleItemSelected">
  </auto-complete-master-data-select>

</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      displayType: String,
      group: String,
      label: String,
      value: String,
      options: Array,
    },
    data: () => ({
      selectedValue: null,
    }),
    computed: {
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
        'getMasterDataName',
      ]),
      getOptions() {
        return this.options || this.getMasterDataAsSelectOptionByGroup(this.group);
      },
    },
    watch: {
      value(val) {
        this.selectValue = val;
      },
      selectedValue(val) {
        this.$emit('input', val);
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.value) {
          this.selectedValue = this.value;
        }
      });
    },
    methods: {
      handleItemSelected(id) {
        this.selectedValue = id;
      },
    },
  }

</script>
